import type { IconData } from '@stacksjs/iconify-core'

export const chartLine: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M376 160v32h65.372L252 381.373l-72-72L76.686 412.686l22.628 22.628L180 354.627l72 72l212-211.999V280h32V160z\"/><path fill=\"currentColor\" d=\"M48 104H16v392h480v-32H48z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default chartLine
